import React from "react";
import { FaFacebookF, FaInstagram, FaTiktok } from "react-icons/fa";
import {
  FooterWrap,
  Inner,
  Columns,
  Col,
  ColTitle,
  LinkList,
  FLink,
  MiniIcon,
  Divider,
  BottomRow,
  PaymentsCenter,
} from "./FooterStyles";

import netopiaImg from "../../assets/netopia.png";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <FooterWrap>
      <Inner>
        <Columns>
          <Col>
            <ColTitle>Ahava Cakes</ColTitle>
            <LinkList>
              <li>
                <FLink href="/despre">Despre Ahava Cakes</FLink>
              </li>
              <li>
                <FLink href="/calitate">Calitate</FLink>
              </li>
              <li>
                <FLink href="/contact">Contact</FLink>
              </li>
            </LinkList>
          </Col>

          <Col>
            <ColTitle>Legal</ColTitle>
            <LinkList>
              <li>
                <FLink href="/politica-de-confidentialitate">
                  Politică de confidențialitate
                </FLink>
              </li>
              <li>
                <FLink href="/termeni-si-conditii">Termeni și condiții</FLink>
              </li>
              <li>
                <FLink href="https://ec.europa.eu/consumers/odr/main/index.cfm?event=main.home2.show&lng=RO">
                  Soluționarea Online a Litigiilor
                </FLink>
              </li>
              <li>
                <FLink href="https://anpc.ro">ANPC</FLink>
              </li>
              <li>
                <FLink href="https://reclamatiisal.anpc.ro/">ANPC - SAL</FLink>
              </li>
            </LinkList>
          </Col>

          <Col>
            <ColTitle>Contact</ColTitle>
            <LinkList>
              <li>
                <FLink href="tel:0775107107">
                  <MiniIcon>📞</MiniIcon>
                  0775 107 107
                </FLink>
              </li>
              <li>
                <FLink
                  href="https://www.google.com/maps/place/Ahava+Cakes+-+Cofet%C4%83rie+Arad/@46.1803242,21.315255,17z/data=!3m1!4b1!4m6!3m5!1s0x474599150cbff7bd:0xb27805b588efb352!8m2!3d46.1803242!4d21.315255!16s%2Fg%2F11sf72cqjn?entry=ttu&g_ep=EgoyMDI2MDIxOC4wIKXMDSoASAFQAw%3D%3D"
                  target="_blank"
                  rel="noreferrer"
                >
                  <MiniIcon>📍</MiniIcon>
                  Str. Elena Ghiba Birta 6-8, 310030 Arad
                </FLink>
              </li>
              <li>
                <FLink href="mailto:office@ahavacakes.ro">
                  <MiniIcon>✉️</MiniIcon>
                  office@ahavacakes.ro
                </FLink>
              </li>
            </LinkList>
          </Col>

          <Col>
            <ColTitle>Social Media</ColTitle>
            <LinkList>
              <li>
                <FLink
                  href="https://www.facebook.com/profile.php?id=61581260180964"
                  target="_blank"
                  rel="noreferrer"
                >
                  <MiniIcon>
                    <FaFacebookF />
                  </MiniIcon>
                  Facebook
                </FLink>
              </li>
              <li>
                <FLink
                  href="https://www.instagram.com/ahava__cakes/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <MiniIcon>
                    <FaInstagram />
                  </MiniIcon>
                  Instagram
                </FLink>
              </li>
              <li>
                <FLink
                  href="https://www.tiktok.com/@ahava.cakes"
                  target="_blank"
                  rel="noreferrer"
                >
                  <MiniIcon>
                    <FaTiktok />
                  </MiniIcon>
                  TikTok
                </FLink>
              </li>
            </LinkList>
          </Col>
        </Columns>

        <PaymentsCenter>
          <img src={netopiaImg} alt="Netopia Payments" />
        </PaymentsCenter>

        <Divider />

        <BottomRow>
          © {year}&nbsp;<strong>AhavaCakes&nbsp;</strong> — Toate drepturile
          rezervate.
        </BottomRow>
      </Inner>
    </FooterWrap>
  );
}
